import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import getConfig from '../../../../../../../../util/config';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateWGNoJoinCode = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const {
    all_photos_mode: allPhotosMode,
    is_web_gallery: isWebGallery,
    joins_enabled: joinsEnabled,
  } = albumFolder;

  const isPublicAllPhotos = allPhotosMode === ALL_PHOTOS_MODE.PUBLIC;

  let url;
  if ((isWebGallery || isPublicAllPhotos) && !joinsEnabled) {
    url = albumFolder?.web_app_urls?.all_photos_access_url;
  } else if (joinsEnabled && !(isWebGallery || isPublicAllPhotos)) {
    url = albumFolder?.onboarding_short_url;
  } else {
    url = `${getConfig().app.baseUrl}/galleries/o/album-folder/${
      albumFolder.id
    }`;
  }

  return (
    <Fragment>
      <p className="marketing-material-flyer-main-copy">
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          id="webGalleryMainCopy"
          defaultMessage="is excited to announce that you’ll be able to view, download, and share all your favorite photos through our Waldo Photos gallery!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>

      <div
        className="marketing-material-flyer-qrcode-secondary wg-flyer-qrcode"
        style={{
          top: '56%',
          right: `calc(46% - ${Math.round((width * 0.27 ?? 500) / 2)}px)`,
        }}
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.35 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset('/marketing-material/MARKETING_FLYER_GENERAL_1_N.png')}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateWGNoJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateWGNoJoinCode;
